import axiosClient from "api/axios_client.js";

const BASE = "/reminder-builder/reminder-setup/source";

// tbl_rem_source. Write calls (and preview-rows, which reads raw rows of any table) are Super Admin only.
// One source, the model schema and the source dropdown are in ../api.js, shared with the other tabs.
const apiReminderSource = {
  create:         (payload)     => axiosClient.post(`${BASE}/create`, payload),
  update:         (id, payload) => axiosClient.put(`${BASE}/update/${id}`, payload),
  getAll:         (payload)     => axiosClient.post(`${BASE}/get-all`, payload),
  delete:         (ids)         => axiosClient.delete(`${BASE}/delete`, { data: { ids } }),
  getModels:      ()            => axiosClient.post(`${BASE}/get-models`, {}),
  // `{ id }` for a saved source, or the unsaved selection `{ root_model, relations, base_where, subject_type, paths }`.
  previewRows:    (payload)     => axiosClient.post(`${BASE}/preview-rows`, payload),
  publish:        (id)          => axiosClient.put(`${BASE}/publish/${id}`),
  archive:        (id)          => axiosClient.put(`${BASE}/archive/${id}`),
  getUsedBy:      (id)          => axiosClient.get(`${BASE}/used-by/${id}`),
};

export default apiReminderSource;
